import NextLink from "components/parts/NextLink";
import { Body } from "app/_components/components/Text/Body";
import { Grid } from "components/layout/Grid";

interface GeminiInstitutionsBannerProps {
  path: string;
}

function GeminiInstitutionsBanner({ path }: GeminiInstitutionsBannerProps) {
  if (!path.includes("/institutions")) {
    return null;
  }

  const isActive = (link: string) => {
    return path.includes(link);
  };

  return (
    <div className="w-full border-b border-gray-200 bg-white">
      <Grid
        smSpacing={0}
        className="mx-80 flex flex-row items-center justify-between px-6 py-4"
      >
        <div>
          <NextLink href="/institutions">
            <Body size="xs" bold>
              Gemini institutions
            </Body>
          </NextLink>
        </div>
        <div className="flex flex-row gap-6">
          <NextLink href="/institutions/exchange">
            <Body
              size="xs"
              bold
              className={
                isActive("/institutions/exchange")
                  ? "text-black"
                  : "text-gray-600"
              }
            >
              Exchange
            </Body>
          </NextLink>
          <NextLink href="/institutions/custody">
            <Body
              size="xs"
              bold
              className={
                isActive("/institutions/custody")
                  ? "text-black"
                  : "text-gray-600"
              }
            >
              Custody
            </Body>
          </NextLink>
          <NextLink href="/institutions/otc">
            <Body
              size="xs"
              bold
              className={
                isActive("/institutions/otc") ? "text-black" : "text-gray-600"
              }
            >
              OTC
            </Body>
          </NextLink>
          <NextLink href="/staking">
            <Body
              size="xs"
              bold
              className={isActive("/staking") ? "text-black" : "text-gray-600"}
            >
              Staking
            </Body>
          </NextLink>
        </div>
      </Grid>
    </div>
  );
}

export default GeminiInstitutionsBanner;
